export default {
  title: 'Historial de edición del menú',
  subtitle: 'Consulta quién cambió precios, disponibilidad y visibilidad de {{company}}, y cuándo.',
  filters: {
    type: {
      label: 'Tipo',
    },
    item: {
      placeholder: 'Todos los elementos',
    },
    event: {
      label: 'Evento',
    },
  },
  columns: {
    when: 'Cuándo',
    who: 'Modificado por',
    type: 'Tipo',
    item: 'Elemento',
    event: 'Evento',
    changes: 'Cambios',
  },
  types: {
    product: 'Producto',
    modifier: 'Modificador',
    category: 'Categoría',
    modifier_group: 'Grupo de modificadores',
    menu: 'Menú',
  },
  events: {
    created: 'Creado',
    updated: 'Actualizado',
    deleted: 'Eliminado',
  },
  fields: {
    name: 'Nombre',
    description: 'Descripción',
    price: 'Precio',
    is_available: 'Disponibilidad',
    is_visible: 'Visibilidad',
    is_available_for_pickup: 'Disponibilidad para recogida',
    is_available_for_delivery: 'Disponibilidad para entrega',
    tax_category_id: 'Categoría de impuestos',
    schedule: 'Horario de visibilidad',
    is_required: 'Obligatorio',
    max_count: 'Máx. de opciones',
  },
  // A dish's price per order method that a price change worked out again (QA24): each its own line.
  order_method_prices: {
    pickup: 'Precio de recogida',
    delivery: 'Precio de entrega a domicilio',
    dine_in: 'Precio en local',
    room_service: 'Precio de servicio a la habitación',
  },
  booleans: {
    on: 'Disponible',
    off: 'No disponible',
    yes: 'Sí',
    no: 'No',
  },
  schedule: {
    always: 'Siempre',
    every_day: 'Todos los días',
  },
  pagination: {
    previous: 'Anterior',
    next: 'Siguiente',
  },
  causers: {
    undo: 'Deshacer',
    orders_terminal: 'Terminal de pedidos',
    approved_by: {
      amigo: 'Amigo, aprobado por {{name}}',
      assistant: 'Asistente, aprobado por {{name}}',
    },
  },
  // Only our team sees it (the Amigo log is FoodAmigos-internal).
  open_agent_log: 'Abrir en el registro de Amigo',
  system: 'Sistema',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Error al cargar el historial de edición del menú',
  },
};
